import React from 'react';
import { useTranslation } from 'react-i18next';
import { Badge, Button, Icon } from '../ui';
import { EXTERNAL_URLS } from '../../constants/urls';
import { LIVE_DARSHAN } from '../../data/home';

export default function LiveDarshanCard({ className = '' }) {
  const { t } = useTranslation();
  return (
    <div className={`live-card card${className ? ` ${className}` : ''}`}>
      <div className="live-card__text">
        <Badge variant="live">LIVE</Badge>
        <div className="live-card__title">{t(LIVE_DARSHAN.title)}</div>
        <div className="live-card__sub">{t(LIVE_DARSHAN.sub)}</div>
        <Button size="sm" variant="outline" href={EXTERNAL_URLS.RAM_MANDIR.LIVE_AARTI} icon={<Icon name="circle-play" size={16} />}>
          {t('Watch Live')}
        </Button>
      </div>
      <img className="live-card__thumb" src={LIVE_DARSHAN.thumb} alt="" loading="lazy" />
    </div>
  );
}
